<div class="template-input">
  @if (showRichEditor()) {
    <div class="relative flex flex-col gap-2">
      <!-- Rótulo e instruções para o editor -->

      <palantir-text type="title" size="base"> Editor de Template </palantir-text>

      <palantir-text type="description">
        Comece a digitar para escrever seu template. Use os gatilhos para acionar o autocompletar de
        variáveis e funções. Blocos como
        <code>{{ '{{#if}}' }}</code> podem ser usados para criar lógicas condicionais.
      </palantir-text>

      <!-- O elemento principal do editor, com contenteditable="true" -->
      <div
        #editor
        id="template-input-{{ uniqueId }}"
        [attr.contenteditable]="readOnly() ? 'false' : 'true'"
        (input)="onInput()"
        (keydown)="onKeyDown($event)"
        (blur)="handleBlur()"
        (click)="onClick($event)"
        role="textbox"
        aria-multiline="true"
        aria-label="Editor de Template"
        class="template-input__editor"
        [ngClass]="{
          'template-input__editor--is-readonly': readOnly(),
          'template-input__editor--no-line-breaks': noLineBreaks(),
        }"
      ></div>

      <!-- Dropdown de sugestões, renderizado condicionalmente -->
      @if (isDropdownVisible()) {
        <app-suggestion-list
          class="fixed"
          [suggestions]="suggestions()"
          [isLoading]="isLoading()"
          [activeIndex]="activeIndex()"
          (itemSelected)="selectItem($event)"
          [style.top]="dropdownPosition()?.top"
          [style.left]="dropdownPosition()?.left"
        ></app-suggestion-list>
      }
    </div>
  }

  <!-- Área de texto para edição e visualização da saída do template Handlebars -->
  @if (showTextEditor()) {
    <div class="flex flex-col gap-2">
      <palantir-text type="title" size="base">Editor de Texto / Saída Handlebars</palantir-text>
      <palantir-text type="description">
        Você pode editar diretamente o código Handlebars abaixo. As alterações serão refletidas no
        editor visual acima.
      </palantir-text>
      <textarea
        id="debug-output-{{ uniqueId }}"
        (input)="onTextareaInput($event)"
        [value]="inputValue()"
        class="template-input__textarea"
        aria-label="Editor de texto para o template Handlebars"
        [readonly]="readOnly()"
        [ngClass]="{
          'template-input__textarea--is-readonly': readOnly(),
          'template-input__textarea--no-line-breaks': noLineBreaks(),
        }"
      ></textarea>
    </div>
  }
</div>
